module.exports = __webpack_public_path__ + "static/media/p_33_0.395d562b.png";